import { SeverityRes } from "@/models/severities.model"
import { PHAClient } from "@/utils/axios"

export const getSeverity = async (): Promise<SeverityRes> => {
  const response = await PHAClient.get(`/api/severity/all`)
  return response.data
}